<template>
    <div class="validate-address-dialog py-3">
        <div>
            <h4 class="mb-0 h4 px-3">Address Validation</h4>
            <hr />
        </div>
        <div class="px-3 py-2">
            <div v-if="validAddress">
                <p>
                    The patient's primary address will be used for documentation, claims and verifying location on a
                    mobile device. Suggested changes are marked in
                    <span class="text-danger">red</span>.
                </p>
                <div class="row g-0">
                    <div class="col-12 col-sm-6 pe-sm-2">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">Original Address</h5>
                                <div class="card-text">
                                    <address>
                                        {{ options.originalAddress.addressLine1 }}
                                        <br v-if="options.originalAddress?.addressLine2?.length > 0" />
                                        {{ options.originalAddress.addressLine2 }} <br />
                                        {{ options.originalAddress.city }} <br />
                                        {{ options.originalAddress.state }}
                                        {{ options.originalAddress.zipCode ? "," : "" }}
                                        {{ formatZipCode(options.originalAddress.zipCode) }} <br />
                                        {{ options.originalAddress.county }} <br />
                                        {{ originalAddressCountry }}
                                    </address>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <div class="card axxess-intelligence-border">
                            <div class="card-body">
                                <h5 class="card-title">Validated Address</h5>
                                <div class="card-text">
                                    <address>
                                        <span
                                            :class="`${checkEqualAddress(
                                                options.originalAddress.addressLine1,
                                                options.updatedAddress.addressLine1
                                            )}`"
                                        >
                                            {{ options.updatedAddress.addressLine1 }}
                                        </span>
                                        <br v-if="options.updatedAddress.addressLine2.length > 0" />
                                        <span
                                            :class="`${checkEqualAddress(
                                                options.originalAddress.addressLine2,
                                                options.updatedAddress.addressLine2
                                            )}`"
                                        >
                                            {{ options.updatedAddress.addressLine2 }}
                                        </span>
                                        <br />
                                        <span
                                            :class="`${checkEqualAddress(
                                                options.originalAddress.city,
                                                options.updatedAddress.city
                                            )}`"
                                        >
                                            {{ options.updatedAddress.city }}
                                        </span>
                                        <br />
                                        <span
                                            :class="`${checkEqualAddress(
                                                options.originalAddress.state,
                                                options.updatedAddress.state
                                            )}`"
                                        >
                                            {{ options.updatedAddress.state }}
                                        </span>
                                        {{ options.updatedAddress.zipCode ? "," : "" }}
                                        <span
                                            :class="`${checkEqualAddress(
                                                options.originalAddress.zipCode,
                                                options.updatedAddress.zipCode
                                            )}`"
                                        >
                                            {{ formatZipCode(options.updatedAddress.zipCode) }}
                                        </span>
                                        <br />
                                        <span
                                            :class="`${checkEqualAddress(
                                                options.originalAddress.county,
                                                options.updatedAddress.county
                                            )}`"
                                        >
                                            {{ options.updatedAddress.county }}
                                        </span>
                                        <br />
                                        <span
                                            :class="`${
                                                originalAddressCountry &&
                                                updatedAddressCountry &&
                                                originalAddressCountry === updatedAddressCountry
                                                    ? ''
                                                    : 'text-danger'
                                            }`"
                                        >
                                            {{ updatedAddressCountry }}
                                        </span>
                                    </address>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!validAddress">
                <p>Please enter Address to Validate.</p>
            </div>
        </div>
        <hr />
        <div class="d-flex justify-content-end px-3">
            <button type="button" class="btn btn-light border border-secondary me-1" @click="cancel()">
                {{ validAddress ? "Keep Current Address" : "Cancel" }}
            </button>
            <button type="button" class="btn btn-primary border border-primary" @click="success()" v-if="validAddress">
                Use Validated Address
            </button>
        </div>
    </div>
</template>

<style src="./ValidateAddress.scss"></style>
<script lang="ts" src="./ValidateAddress.ts"></script>
